import axios from "axios";
import env from "../config";
import store from "../store";

//import { userAdmin } from '@/api/mock';
/**
 * Login by username and password
 *
 * @param {String} username user name
 * @param {String} password user password
 */

const client = axios.create({
  baseURL: env.API_ENDPOINT,
  json: true,
});

export default {
  async execute(method, resource, data) {
    // inject the accessToken for each request
    return client({
      method,
      url: resource,
      data,
      headers: {
        customerId: store.getters.companyIdDropdown == null ? "" : store.getters.companyIdDropdown      
      },
    }).then((req) => {
      return req.data;
    });
  },
  async loginByEmail(userName, password,grant_type) {
    try {
      let params = { userName: userName, password: password,grant_type:grant_type};
      return this.execute("post", "auth/signin", params);
    } catch (err) {
      console.warn(`[loginByEmail] ${err}`);
    }
  },
};

/**
 * Get user information by token
 *
 * @param {String} token user token
 */
export const getUserInfo = async (token) => {
  console.log(`[getUserInfo] token ${token}`);
  let user = {};
  try {
    if (!token) {
      throw new Error("Invalid token");
    }

    // if (token === userAdmin.token) {
    //   user = userAdmin;
    // }
  } catch (err) {
    console.warn(`[getUserInfo] ${err}`);
  }
  return { user };
};
